'use strict';

angular.module('app.editUserProfile', [])
	.controller('editUserProfileCtrl', ['$scope', '$rootScope', '$http' , '$modalInstance', '$upload', '$modal', 'editUserProfileService',
		function ($scope, $rootScope, $http, $modalInstance, $upload, $modal, editUserProfileService){
		    var definitions = angular.copy($rootScope.definitions);
		    $scope.preLoaded = false;
		    $scope.croppedImage = null;
		    $scope.croppedImageOptions = {}; 
		    $scope.croppedImageOptions.image= null;
		    $scope.croppedImageOptions.viewSizeWidth= 150;
		    $scope.croppedImageOptions.viewSizeHeight= 150;
		    $scope.croppedImageOptions.viewShowRotateBtn= true;
		    $scope.croppedImageOptions.rotateRadiansLock= true;
		    $scope.croppedImageOptions.outputImageWidth= 20 ;
		    $scope.croppedImageOptions.outputImageHeight= 20;
		    $scope.croppedImageOptions.outputImageRatioFixed= false;
		    $scope.croppedImageOptions.outputImageType= "jpeg";
		    $scope.croppedImageOptions.outputImageSelfSizeCrop= true;
		    $scope.croppedImageOptions.viewShowCropTool= true;


		    $scope.bounds = {};
		    $scope.bounds.left = 0;
		    $scope.bounds.right = 0;
		    $scope.bounds.top = 0;
		    $scope.bounds.bottom = 0;

		    $scope.preLoadData = function(){
		        $scope.firstName = $scope.index.firstName;
		        $scope.lastName = $scope.index.lastName;
		        $scope.email = $scope.index.email;
		        $scope.title = $scope.index.userTitle;

		        $scope.renderCountry();
		        $scope.renderImage($scope.index);

		        $scope.preLoaded = true;
		    }


		    $scope.renderCountry = function() {
		    	$scope.countries = definitions.countries;
		    	$scope.countries.forEach(function (val) {
                    if ($scope.index.country != null) {
                        if (val.id == $scope.index.country.id) {
                            val.ticked = true;
                            $scope.outputCountry = val;
                        }
                    }
                })
		    }

		    $scope.renderImage = function(index){
		        $('.upload-image-holder .image').css('backgroundImage', 'url(' + $rootScope.apiUrl + 'uploads/profile/' + index.image +  ')');
		    }

		    if(!$scope.preLoaded){
		        $scope.preLoadData();
		    }

		    $scope.save = function(){
		        var params = {
		            userId: $scope.index.id,
		            firstName: $scope.firstName,
		            lastName: $scope.lastName,
		            email: $scope.email,
		            country: $scope.selectCountry.length != 0 ? $scope.selectCountry[0].id : null,
		            title: $scope.title,
		            image: $scope.croppedImage
		        }

		        editUserProfileService.updateUserProfile(params, true)
		        	.then(function(responseSaveUserProfile) {
		                $modalInstance.close(function () {
		                    $log.info('Close Modal now');
		            	})
		        	}, function(responseSaveUserProfile) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseSaveUserProfile.message;
		        	})
		    }

		    var dataURItoBlob = function(dataURI) {
		        // convert base64/URLEncoded data component to raw binary data held in a string
		        var byteString;
		        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
		            byteString = atob(dataURI.split(',')[1]);
		        } else {
		            byteString = decodeURI(dataURI.split(',')[1]);
		        }
		        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
		        var array = [];
		        for(var i = 0; i < byteString.length; i++) {
		            array.push(byteString.charCodeAt(i));
		        }
		        return new Blob([new Uint8Array(array)], {type: mimeString});
		    };

		    $scope.uploadCroppedImage = function(){

		        var blob = dataURItoBlob($scope.croppedImage);
		        var fd = new FormData();
		        fd.append("picture", blob);

		        var  req = {
		            url: $rootScope.apiUrl + 'upload',
		            method: 'POST',
		            headers: {'Content-Type': undefined},
		            data: fd
		        }

		        $http(req)
		            .success(function(responseUploadCroppedImage){
		                $scope.croppedImage = responseUploadCroppedImage.image;
		                $scope.save();
		            })
		            .error(function(responseUploadCroppedImage){

		                })

		    }    

		    $scope.updateProfile = function(){
		        if($scope.croppedImageOptions.image != null){
		            $scope.$broadcast('cropImageSave');
		        }else{
		            $scope.save();    
		        }
		        
		    }

		    $scope.resetPassword = function(){
		        var data ={
		            userEmail: $scope.index.email,
		            hostName: window.location.hostname     
		        }

		        var req = {
		            url: $rootScope.apiUrl + 'forgotPassword',
		            method: 'POST',
		            data: JSON.stringify(data)
		        }

		        $http(req).success(function (response) {
		            
		        }) .error(function (data) {
		            })  
		    }

		    $scope.changePassword = function () {
		        var changePasswordModalInstance = $modal.open({       
		            scope: $scope,    
		            templateUrl: 'app/admin/partials/changePassword.html?app_v=deployDate',
		            controller: 'AdminChangePasswordCtrl'
		        });

		        $scope.changePasswordModalInstance = changePasswordModalInstance;
		    }

}])

.controller('AdminChangePasswordCtrl', function($scope, $rootScope, $http){
    $scope.save = function(isValid){        
        $scope.errorMessage = null;

        if(isValid) {
            var passwordData = {
                flag: true,
                email: $scope.index.email,
                newPassword: $scope.newPassword
            }

            var req = {
                url: $rootScope.apiUrl + 'changepassword',
                method: 'POST',
                data: JSON.stringify(passwordData)
            }

            $http(req).success(function(data){
                
                $scope.successMessage = data.message;

                $scope.changePasswordModalInstance.close();
            })
            .error(function(data){
                $scope.errorMessage = data.message;
        
                for(var propertyKey in data){
                    //$scope.newProject["project_" + propertyKey].$setValidity("required", false);

                    return;
                }
            }); 
        }           
    }
})
